/** @format */

import benefitShipping from './images/benefit-shipping.png';
import benefitPayment from './images/benefit-payment.png';
import benefitOriginal from './images/benefit-original.png';
import benefitPharmaCare from './images/benefit-pharma-care.png';

export const BENEFITS = [
	{
		id: 'shipping',
		image: benefitShipping,
		title: 'Envíos a todo Chile',
		subtitle: 'Rápidos y seguros',
	},
	{
		id: 'payment',
		image: benefitPayment,
		title: 'Compra fácil y segura',
		subtitle: 'Múltiples medios de pago',
	},
	{
		id: 'original',
		image: benefitOriginal,
		title: 'Productos originales',
		subtitle: 'Directo de laboratorios',
	},
	{
		id: 'pharma-care',
		image: benefitPharmaCare,
		title: 'Tu salud nos importa',
		subtitle: 'Asesoría farmacéutica',
	},
];
